import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useLeadsDocuments(leadIds: string[], componentName = "useLeadsDocuments") {
  const { get, post } = useApiHelper(apiConfig(componentName));

  const leadsDocuments = useQuery({
    queryKey: ["leadsDocuments", leadIds],
    queryFn: () => post(
      `/lead/documents/partial`,
      leadIds
    ),
    enabled: leadIds.length > 0,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    leadsDocuments,
  }

}